// Class: lime.net._HTTPRequestErrorResponse

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var _HTTPRequestErrorResponse = function(error,responseData) {
	this.error = error;
	this.responseData = responseData;
}

// Meta

_HTTPRequestErrorResponse.__name__ = "lime.net._HTTPRequestErrorResponse";
_HTTPRequestErrorResponse.__isInterface__ = false;
_HTTPRequestErrorResponse.prototype = {
	
};
_HTTPRequestErrorResponse.prototype.__class__ = _HTTPRequestErrorResponse.prototype.constructor = $hxClasses["lime.net._HTTPRequestErrorResponse"] = _HTTPRequestErrorResponse;

// Init



// Statics




// Export

exports.default = _HTTPRequestErrorResponse;